module.exports = __webpack_public_path__ + "static/img/bottom1.ff1f448e.png";